import { TeamOutlined, UserAddOutlined, UsergroupAddOutlined, FormOutlined, FundOutlined, UnorderedListOutlined, KeyOutlined, FileExcelOutlined, HistoryOutlined, ContactsOutlined, CalendarOutlined, PieChartOutlined, EditOutlined } from '@ant-design/icons'

import MESSAGES from '../../services/messages'
import { displayMessage } from '../../services/helper'
const {
  RESET_PASSWORD, MY_PROFILE, HOLIDAYS_LIST, MONITORY_ROOM, EXERCISE_ROOM, MONITOR_STATUS_HISTORY, DENTIST_LIST, PATIENT_LIST, CONTROLS_HISTORY, CONTROLS_HISTORY_OLD, MONITOR_LIST, ADD_PATIENT_AND_DENTIST, DASHBOARD
} = MESSAGES

export const sideMenuItensIconsStyle = {
  fontSize: 20
}

export const topMenuItensIconsStyle = {
  fontSize: 20
}


const generateMenus = () => {
  
  return {
    adminSideMenuItens: [
      // {
      //   key: "dashboard/administrator",
      //   icon: <PieChartOutlined style={sideMenuItensIconsStyle} />,
      //   title: "Dashboard",
      // },
      {
        key: "/dentist/list",
        icon: <TeamOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('DENTIST_LIST'),
      },
      // {
      //   key: "/monitor/list",
      //   icon: <ContactsOutlined style={sideMenuItensIconsStyle} />,
      //   title: MONITOR_LIST,
      // },
      {
        key: "/patient/list",
        icon: <UsergroupAddOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('PATIENT_LIST')
      },
      {
        key: "/control_old/list",
        icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('CONTROLS_HISTORY_OLD')
      },
      {
        key: "/control/list",
        icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('CONTROLS_HISTORY')
      },
      // {
      //   key: "/exercise_control/list",
      //   icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
      //   title: displayMessage('EXERCISE_HISTORY')
      // },
      // {
      //   key: "/status-history/list",
      //   icon: <HistoryOutlined style={sideMenuItensIconsStyle} />,
      //   title: MONITOR_STATUS_HISTORY
      // },
      {
        key: "/holiday/list",
        icon: <CalendarOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('HOLIDAYS_LIST')
      },
      {
        key: "/config",
        icon: <EditOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('RULE_CONFIG_TITLE')
      },
      {
        key: "/reset-password",
        icon: <KeyOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('RESET_PASSWORD')
      },
      {
        key: "/exercise/list",
        icon: <FormOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('EXERCISE_LIST')
      },
      {
        key: "/protocol",
        icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('PROTOCOLS_LIST')
      }, 
      /* //Comentado até próximo deploy 
      */
      // {
      //   key: "/add-dentists-and-patients",
      //   icon: <FileExcelOutlined style={sideMenuItensIconsStyle} />,
      //   title: ADD_PATIENT_AND_DENTIST
      // }
    ],
    dentistSideMenuItens: [
      {
        key: "/patient/list",
        icon: <UsergroupAddOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('PATIENT_LIST')
      },
      // {
      //   key: "/exercise/list",
      //   icon: <FormOutlined style={sideMenuItensIconsStyle} />,
      //   title: displayMessage('EXERCISE_LIST')
      // },
      {
        key: "/control_old/list",
        icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('CONTROLS_HISTORY_OLD')
      },
      {
        key: "/control/list",
        icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('CONTROLS_HISTORY')
      },
      // {
      //   key: "/exercise_control/list",
      //   icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
      //   title: displayMessage('EXERCISE_HISTORY')
      // },
      // {
      //   key: "/dashboard",
      //   icon: <FundOutlined style={sideMenuItensIconsStyle} />,
      //   title: DASHBOARD
      // },
      {
        key: "/reset-password",
        icon: <KeyOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('RESET_PASSWORD')
      }
    ],
    monitorSideMenuItens: [
      {
        key: "/patient/list",
        icon: <UsergroupAddOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('PATIENT_LIST')
      },
      // {
      //   key: "/exercise/list",
      //   icon: <FormOutlined style={sideMenuItensIconsStyle} />,
      //   title: displayMessage('EXERCISE_LIST')
      // },
      {
        key: "/control_old/list",
        icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('CONTROLS_HISTORY_OLD')
      },
      {
        key: "/control/list",
        icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('CONTROLS_HISTORY')
      },
      // {
      //   key: "/exercise_control/list",
      //   icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
      //   title: displayMessage('EXERCISE_HISTORY')
      // },
      // {
      //   key: "/monitory-room",
      //   icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
      //   title: MONITORY_ROOM
      // },
      // {
      //   key: "/exercise-room",
      //   icon: <FormOutlined style={sideMenuItensIconsStyle} />,
      //   title: EXERCISE_ROOM
      // },
      {
        key: "/reset-password",
        icon: <KeyOutlined style={sideMenuItensIconsStyle} />,
        title: displayMessage('RESET_PASSWORD')
      }
    ],

    topMenuItens: [
      // {
      //   key: "/profile",
      //   icon: <UserAddOutlined style={topMenuItensIconsStyle} />,
      //   title: MY_PROFILE,
      // },
    ]
  }
}
export default generateMenus

  // {
  //   adminSideMenuItens: [
  //     // {
  //     //   key: "dashboard/administrator",
  //     //   icon: <PieChartOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: "Dashboard",
  //     // },
  //     {
  //       key: "/dentist/list",
  //       icon: <TeamOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('DENTIST_LIST'),
  //     },
  //     // {
  //     //   key: "/monitor/list",
  //     //   icon: <ContactsOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: MONITOR_LIST,
  //     // },
  //     {
  //       key: "/patient/list",
  //       icon: <UsergroupAddOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('PATIENT_LIST')
  //     },
  //     {
  //       key: "/control_old/list",
  //       icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('CONTROLS_HISTORY_OLD')
  //     },
  //     {
  //       key: "/control/list",
  //       icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('CONTROLS_HISTORY')
  //     },
  //     // {
  //     //   key: "/exercise_control/list",
  //     //   icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: displayMessage('EXERCISE_HISTORY')
  //     // },
  //     // {
  //     //   key: "/status-history/list",
  //     //   icon: <HistoryOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: MONITOR_STATUS_HISTORY
  //     // },
  //     {
  //       key: "/holiday/list",
  //       icon: <CalendarOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('HOLIDAYS_LIST')
  //     },
  //     {
  //       key: "/config",
  //       icon: <EditOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('RULE_CONFIG_TITLE')
  //     },
  //     {
  //       key: "/reset-password",
  //       icon: <KeyOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('RESET_PASSWORD')
  //     },
  //     // {
  //     //   key: "/add-dentists-and-patients",
  //     //   icon: <FileExcelOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: ADD_PATIENT_AND_DENTIST
  //     // }
  //   ],
  //   dentistSideMenuItens: [
  //     {
  //       key: "/patient/list",
  //       icon: <UsergroupAddOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('PATIENT_LIST')
  //     },
  //     {
  //       key: "/control_old/list",
  //       icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('CONTROLS_HISTORY_OLD')
  //     },
  //     {
  //       key: "/control/list",
  //       icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('CONTROLS_HISTORY')
  //     },
  //     // {
  //     //   key: "/exercise_control/list",
  //     //   icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: displayMessage('EXERCISE_HISTORY')
  //     // },
  //     // {
  //     //   key: "/dashboard",
  //     //   icon: <FundOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: DASHBOARD
  //     // },
  //     {
  //       key: "/reset-password",
  //       icon: <KeyOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('RESET_PASSWORD')
  //     }
  //   ],
  //   monitorSideMenuItens: [
  //     {
  //       key: "/patient/list",
  //       icon: <UsergroupAddOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('PATIENT_LIST')
  //     },
  //     {
  //       key: "/control_old/list",
  //       icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('CONTROLS_HISTORY_OLD')
  //     },
  //     {
  //       key: "/control/list",
  //       icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('CONTROLS_HISTORY')
  //     },
  //     // {
  //     //   key: "/exercise_control/list",
  //     //   icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: displayMessage('EXERCISE_HISTORY')
  //     // },
  //     // {
  //     //   key: "/monitory-room",
  //     //   icon: <UnorderedListOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: MONITORY_ROOM
  //     // },
  //     // {
  //     //   key: "/exercise-room",
  //     //   icon: <FormOutlined style={sideMenuItensIconsStyle} />,
  //     //   title: EXERCISE_ROOM
  //     // },
  //     {
  //       key: "/reset-password",
  //       icon: <KeyOutlined style={sideMenuItensIconsStyle} />,
  //       title: displayMessage('RESET_PASSWORD')
  //     }
  //   ],

  //   topMenuItens: [
  //     // {
  //     //   key: "/profile",
  //     //   icon: <UserAddOutlined style={topMenuItensIconsStyle} />,
  //     //   title: MY_PROFILE,
  //     // },
  //   ]
  // }